// src/services/uploadPaymentServices.ts
import axios from 'axios'
import { getTokenConfig } from '../../../../../src/auth'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Valida el Excel de Pago de Servicios (modo validación).
 */
export const uploadPaymentServicesExcel = async (file: File) => {
  const config = await getTokenConfig()
  const base64File = await toBase64(file)

  const url = `${API_URL}/paymentServicesInsert`

  const response = await axios.post(
    url,
    {
      fileName: file.name,
      fileType: file.type,
      fileContent: base64File,
    },
    {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'application/json',
      },
    }
  )

  return response.data
}

/**
 * Procesa (Agregar, Editar, Eliminar) los PaymentServices validados.
 */
export const processPaymentServices = async (rows: any[]) => {
  const config = await getTokenConfig()
  const url = `${API_URL}/paymentServicesInsert`

  await axios.post(
    url,
    {
      type: 'bulk_update_paymentservices',
      data: rows,
    },
    {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'application/json',
      },
    }
  )
}

/**
 * Helper: convierte File a base64 (solo contenido)
 */
const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        const [, base64] = reader.result.split(',')
        resolve(base64)
      } else {
        reject(new Error('Formato inesperado al leer el archivo'))
      }
    }
    reader.onerror = (err) => reject(err)
  })
